/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetFollowingBusinessCategoriesLv2ResponseAllOf,
    GetFollowingBusinessCategoriesLv2ResponseAllOfFromJSON,
    GetFollowingBusinessCategoriesLv2ResponseAllOfFromJSONTyped,
    GetFollowingBusinessCategoriesLv2ResponseAllOfToJSON,
} from './GetFollowingBusinessCategoriesLv2ResponseAllOf';
import {
    GetFollowingBusinessCategoriesLv2ResponseAllOfData,
    GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSON,
    GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSONTyped,
    GetFollowingBusinessCategoriesLv2ResponseAllOfDataToJSON,
} from './GetFollowingBusinessCategoriesLv2ResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetFollowingBusinessCategoriesLv2Response
 */
export interface GetFollowingBusinessCategoriesLv2Response {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetFollowingBusinessCategoriesLv2Response
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetFollowingBusinessCategoriesLv2Response
     */
    message: string;
    /**
     * 
     * @type {GetFollowingBusinessCategoriesLv2ResponseAllOfData}
     * @memberof GetFollowingBusinessCategoriesLv2Response
     */
    data: GetFollowingBusinessCategoriesLv2ResponseAllOfData;
}

export function GetFollowingBusinessCategoriesLv2ResponseFromJSON(json: any): GetFollowingBusinessCategoriesLv2Response {
    return GetFollowingBusinessCategoriesLv2ResponseFromJSONTyped(json, false);
}

export function GetFollowingBusinessCategoriesLv2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFollowingBusinessCategoriesLv2Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetFollowingBusinessCategoriesLv2ResponseToJSON(value?: GetFollowingBusinessCategoriesLv2Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetFollowingBusinessCategoriesLv2ResponseAllOfDataToJSON(value.data),
    };
}

